<div class="container">
  <div class="left" (click)="goBack()">
    <div class="lesser"></div>
  </div>
  <div class="indicators">
    <div
      class="indicator"
      *ngFor="let page of pages; let i = index"
      [ngClass]="{ active: page.active }"
      (click)="gotoPage(page)"></div>
  </div>
  <div class="right" (click)="goForward()">
    <div class="greater"></div>
  </div>
</div>
